<div class="carousel">
  <ng-container *ngFor="let file of files; let i = index">
    <ng-container [ngSwitch]="file.isVideo">
      <ng-container *ngIf="i === currentSlide">
        <img alt="carousel-img" [attr.src]="file.src" class="asset" @carouselAnimation *ngSwitchCase="false" />
        <div class="video-container" *ngSwitchCase="true">
          <video
            class="asset"
            *ngIf="file.src"
            width="1330"
            height="370"
            controls
            (play)="videoClicked(file.isVideo)"
            (fullscreenchange)="videoClicked(file.isVideo)"
            (webkitfullscreenchange)="videoClicked(file.isVideo)"
            (mozfullscreenchange)="videoClicked(file.isVideo)"
            #teaserVideo
          >
            <source [attr.src]="file.src" type="video/mp4" />
          </video>
          <div class="asset" [ngClass]="{ spinner: !file.src }" *ngIf="!file.src">
            <span class="fa fa-spinner fa-spin fa-3x"></span>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>

  <div class="nav">
    <button title="back" class="control prev" (click)="onPreviousClick()">
      <span class="arrow left"></span>
    </button>
    <ul class="page-indicators">
      <li *ngFor="let file of files; let i = index" class="nav-pages">
        <span [ngClass]="i === currentSlide ? 'fa fa-circle' : 'fa fa-circle-thin'" (click)="navToPage(i)"></span>
      </li>
    </ul>
    <button title="next" class="control next" (click)="onNextClick()">
      <span class="arrow right"></span>
    </button>
  </div>
</div>
